import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Package, Truck } from "lucide-react"
import Button from "../../common/Button.js"
import { shouldHideMlSheetDispatch } from "../../../utils/networkMode.js"
import { useAuth } from "../../../context/AuthContext.js"

const DashboardQuickActionButtons = ({ hubBookingAllowed }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { user } = useAuth()
  const showDispatch = !shouldHideMlSheetDispatch(user)
  const showBooking = hubBookingAllowed && user?.role !== "Hub Admin"

  return (
    <>
      {showBooking && (
        <Button
          variant="primary"
          mobileIconOnly
          mobileLabel={t("dashboard.booking")}
          icon={Package}
          onClick={() => navigate("/shipments/add")}
        >
          {t("dashboard.booking")}
        </Button>
      )}
      {showDispatch && (
        <Button
          variant="orange"
          mobileIconOnly
          mobileLabel={t("dashboard.dispatch")}
          icon={Truck}
          onClick={() => navigate("/ml-sheets/add")}
        >
          {t("dashboard.dispatch")}
        </Button>
      )}
      {!showDispatch && (
        <Button
          variant="orange"
          mobileIconOnly
          mobileLabel={t("sidebar.ogclTransferRequests")}
          icon={Truck}
          onClick={() => navigate("/ogcl-transfer-requests")}
        >
          {t("sidebar.ogclTransferRequests")}
        </Button>
      )}
    </>
  )
}

export default DashboardQuickActionButtons
